export default __webpack_public_path__ + "30a6b03967447c8ecdec2b66c31d3b33.svg";